import { bl_dgmkt_message_template_hdr_RowClass } from '../../../dbschema/bl_dgmkt_message_template_hdr.model'
import { bl_dgmkt_message_template_line_RowClass } from '../../../dbschema/bl_dgmkt_message_template_line.model';
import {BaseContainerModel} from '../../base-container.model'
export class DgMktMessageTemplateContainerModel extends BaseContainerModel{
    bl_dgmkt_message_template_hdr : bl_dgmkt_message_template_hdr_RowClass = new bl_dgmkt_message_template_hdr_RowClass();
    bl_dgmkt_message_template_line : bl_dgmkt_message_template_line_RowClass [] = [];
    bl_dgmkt_message_template_ext : bl_dgmkt_message_template_line_RowClass [] = [];
}